import { render, staticRenderFns } from "./NutritionTable.vue?vue&type=template&id=7bc8f852&scoped=true&"
import script from "./NutritionTable.vue?vue&type=script&lang=ts&"
export * from "./NutritionTable.vue?vue&type=script&lang=ts&"
import style0 from "./NutritionTable.vue?vue&type=style&index=0&id=7bc8f852&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc8f852",
  null
  
)

export default component.exports